import React, { Component } from 'react';
import {StyleSheet, Text, View, Animated, SafeAreaView, Pressable, FlatList, Easing, Dimensions, Image} from 'react-native';

import { Checkbox } from 'react-native-paper';
import { Overlay } from 'react-native-elements';

import Ionicons from 'react-native-vector-icons/Ionicons';

import GameData from './GameData';
import SkillRow from './SkillRow';

import * as Font from 'expo-font';

const fps = 10;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

class SkillsScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
	  tab: "vice",
      refresh: false,
      showOverlay: false,
      overlayTitle: "",
      overlayText: "",
    }
  
	GameData.skillScreen = this;
  
  }

	/*
  componentDidMount() {
    this.interval = setInterval(function() {
            this.setState({refresh: !this.state.refresh});
          }.bind(this), fpsDuration);
    }
    
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  */

  renderSkills({ item }) {
    if (GameData.skills[item].category == this.state.tab && (GameData.skills[item].lvl > 0 || GameData.skills[item].exp > 0)) {
      return (
        <Pressable onPress={() =>  this.showVice(item)} style={styles.item}>
            <SkillRow skill={item}/>
        </Pressable>
      )
    }
    else {
      return (null);
    }
  }

  showVice(vice) {
    let schemeText = GameData.skills[vice].description + "\n\n";

    schemeText += "Level: " + GameData.skills[vice].lvl + "\n";

    schemeText += "Experience: " + Math.floor(GameData.skills[vice].exp) + " / " + GameData.getExpToNextLvl(vice) + "\n";

    schemeText += "Time Modifier: Base Time / ( 1+" + Math.round((GameData.getSkillMod(vice)-1)*1000)/1000 + "*x%)" + "\n";

    this.setState({
      showOverlay: true,
      overlayTitle: GameData.skills[vice].name,
      overlayText: schemeText,
    });
  }

  closeOverlay() {
    this.setState({
      showOverlay: false,
    });    
  }
  
  getTitleText() {
	  if (this.state.tab == "vice") {
		  return "Vices"
	  }
	 if (this.state.tab == "map") {
		  return "Maps"
	 }
	 if (this.state.tab == "knowledge") {
		  return "Knowledge"
	 }
	  return "Error"
  }
  
  setCategory(category) {
	  this.setState({tab: category,});
  }

  render() {
    return (
      <View style={styles.container}>
        <Overlay visible={this.state.showOverlay} onBackdropPress={this.closeOverlay.bind(this)} overlayStyle={styles.overlayStyle}>
          <Text style={styles.overlayTitle}>{this.state.overlayTitle}</Text>
          <Text style={styles.overlayText}>{this.state.overlayText}</Text>
          <Pressable onPress={this.closeOverlay.bind(this)}>
            <Text style={styles.overlayPress}>Close</Text>
          </Pressable>
        </Overlay>
        <Text style={styles.title}>{this.getTitleText()}</Text>
		<View style={styles.categories}>
          <Pressable onPress={this.setCategory.bind(this, "vice")}>
            <Ionicons
	          name="md-medical-outline"
	          size={30}
	          color={this.state.tab == "vice" ? "#f44336" : "#ffffff"}
	        />
          </Pressable>
		  <Pressable onPress={this.setCategory.bind(this, "map")}>
            <Ionicons
	          name="md-map-outline"
	          size={30}
	          color={this.state.tab == "map" ? "#f44336" : "#ffffff"}
	        />
          </Pressable>
		  <Pressable onPress={this.setCategory.bind(this, "knowledge")}>
            <Ionicons
	          name="md-key-outline"
	          size={30}
	          color={this.state.tab == "knowledge" ? "#f44336" : "#ffffff"}
	        />
          </Pressable>
        </View>
        <View style={styles.skills}>
          <FlatList
            data={Object.keys(GameData.skills)}
            renderItem={this.renderSkills.bind(this)}
            //extraData={this.state.refresh}
			keyExtractor={item => item}
          />
        </View>
      </View >
    )
  }
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 20,
    flex: 1,
    backgroundColor: '#000000',
  },
  title: {
    color: '#ffffff',
    fontFamily: 'Alegreya-Regular',
    fontSize: 24,
    textAlign: 'center',
    borderBottomWidth: 2,
    borderColor: '#ffffff',
  },
  item: {
    margin: 2,
    borderWidth: 2,
    borderColor: '#ffffff',
  },
  overlayTitle: {
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    textAlign: 'center',
    textDecorationLine: 'underline',
    fontSize: 24,
  },
  overlayText: {
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    textAlign: 'left',
    fontSize: 16,
  },
  overlayPress: {
    borderWidth: 2,
    borderRadius: 6,
    padding: 2,
    marginTop: 20,
	fontSize: 20,
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    borderColor: '#ffffff',
    backgroundColor: '#000000',
    textAlign: 'center',
    alignSelf: 'center',
  },
  overlayStyle: {
    borderWidth: 2,
    padding: 20,
    maxWidth: '98%',
    fontFamily: 'Alegreya-Regular',
    borderColor: '#ffffff',
    backgroundColor: '#000000'
  },
  skills: {
	flex: 1,
    width: '100%'
  },
  categories: {
    flexDirection: 'row',
    alignItems: 'center',
	justifyContent: 'space-around',
	width:'100%',
	marginTop: 10,
	marginBottom: 10,
  },  
  category: {
	marginLeft: 15,
	marginRight: 15,
  },
});

export default SkillsScreen;